import { render, staticRenderFns } from "./SFormSelectProductComp.vue?vue&type=template&id=5d41078c&"
import script from "./SFormSelectProductComp.vue?vue&type=script&lang=js&"
export * from "./SFormSelectProductComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports